import React from 'react'
import './App.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoAlertCircleOutline,
  IoCheckmarkCircleOutline,
  IoInformationCircleOutline,
} from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const C = {
  ink: '#14213d',
  muted: '#6b7590',
  line: '#e6e9f2',
  track: '#eef1f8',
  blue: '#2f6fed',
  down: '#e5484d',
  ok: '#14925e',
  warn: '#b86e00',
}

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');

.ae { font-family: 'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif; color: ${C.ink}; max-width: 760px; margin: 0 auto; padding: 8px 0 64px; }
.ae *, .ae *::before, .ae *::after { box-sizing: border-box; }
.ae h1, .ae h2, .ae p { margin: 0; }

.ae-back { display: inline-flex; align-items: center; gap: 4px; background: none; border: 0; padding: 4px 8px 4px 0; color: ${C.muted}; font: 600 14px/1 'Manrope', sans-serif; cursor: pointer; margin-top:40px }
.ae-back:hover { color: ${C.ink}; }
.ae-back:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; border-radius: 6px; }

.ae-head { margin: 14px 0 20px; }
.ae .ae-title { font-size: 26px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.2; color: ${C.ink}; text-align: left; }
.ae .ae-sub { margin-top: 6px; font-size: 14px; font-weight: 500; color: ${C.muted}; }

.ae-card { background: #fff; border: 1px solid ${C.line}; border-radius: 14px; padding: 24px; margin-bottom: 16px; }
.ae-card-h { display: flex; align-items: center; gap: 10px; margin-bottom: 18px; }
.ae-step { width: 26px; height: 26px; border-radius: 50%; background: ${C.ink}; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 12.5px; font-weight: 800; }
.ae .ae-card-t { font-size: 16px; font-weight: 800; }

.ae-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 18px; }
.ae-full { grid-column: 1 / -1; }

.ae-field label { display: block; margin: 0 0 6px; font-size: 13px; font-weight: 700; color: ${C.ink}; }
.ae-field label i { color: ${C.down}; font-style: normal; margin-left: 2px; }
.ae-hint { margin-top: 5px; font-size: 12px; color: ${C.muted}; font-weight: 500; }

.ae-input { width: 100%; height: 44px; padding: 0 14px; border: 1px solid #d5dae8; border-radius: 10px; background: #fff; color: ${C.ink}; font: 500 14.5px 'Manrope', sans-serif; transition: border-color .15s ease, box-shadow .15s ease; }
textarea.ae-input { height: auto; padding: 12px 14px; line-height: 1.55; resize: vertical; min-height: 120px; }
.ae-input:hover { border-color: #b9c1d6; }
.ae-input:focus { outline: none; border-color: ${C.blue}; box-shadow: 0 0 0 3px rgba(47,111,237,.16); }
.ae-input::placeholder { color: #9aa3b8; }
.ae-input:invalid { box-shadow: none; }

.ae-check { display: flex; align-items: center; gap: 12px; cursor: pointer; font-size: 14.5px; font-weight: 700; margin-bottom: 14px; }
.ae-check input { width: 20px; height: 20px; margin: 0; accent-color: ${C.blue}; cursor: pointer; flex: 0 0 auto; }
.ae-check.is-locked { cursor: not-allowed; color: ${C.muted}; }
.ae-check.is-locked input { cursor: not-allowed; }

.ae-note { display: flex; gap: 12px; padding: 14px 16px; border-radius: 12px; background: rgba(47,111,237,.07); border: 1px solid rgba(47,111,237,.22); font-size: 13.5px; line-height: 1.55; }
.ae-note svg { flex: 0 0 auto; margin-top: 2px; color: ${C.blue}; }
.ae-note b { display: block; color: ${C.blue}; font-weight: 700; margin-bottom: 2px; }
.ae-note.is-warn { background: rgba(184,110,0,.08); border-color: rgba(184,110,0,.3); }
.ae-note.is-warn svg, .ae-note.is-warn b { color: ${C.warn}; }

.ae-msg { display: flex; align-items: flex-start; gap: 10px; padding: 12px 16px; margin-bottom: 16px; border-radius: 12px; font-size: 14px; font-weight: 600; cursor: pointer; }
.ae-msg svg { flex: 0 0 auto; margin-top: 1px; }
.ae-msg.is-err { background: rgba(229,72,77,.08); border: 1px solid rgba(229,72,77,.3); color: #b3282d; }
.ae-msg.is-ok { background: rgba(20,146,94,.08); border: 1px solid rgba(20,146,94,.3); color: #0f7048; }

.ae-load { display: flex; justify-content: center; padding: 72px 0; }

.ae-actions { display: flex; justify-content: flex-end; }
.ae-btn { min-width: 140px; height: 46px; padding: 0 26px; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 10px; background: ${C.ink}; color: #fff; font: 700 15px 'Manrope', sans-serif; cursor: pointer; transition: background .15s ease; }
.ae-btn:hover:not(:disabled) { background: #1f3260; }
.ae-btn:disabled { opacity: .6; cursor: not-allowed; }
.ae-btn:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; }

@media (max-width: 640px) {
  .ae-grid { grid-template-columns: 1fr; }
  .ae-card { padding: 18px; }
  .ae .ae-title { font-size: 22px; }
  .ae-actions .ae-btn { width: 100%; }
}
`

const Field = ({ label, required, hint, full, children }) => (
  <div className={`ae-field ${full ? 'ae-full' : ''}`}>
    <label>
      {label}
      {required ? <i>*</i> : null}
    </label>
    {children}
    {hint ? <div className="ae-hint">{hint}</div> : null}
  </div>
)

class Updateeventdetails extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      error: '',
      successError: '',
      errorDisplay: 'none',
      businessname: localStorage.getItem('businessname'),
      eventname: this.props.location.state.eventname,
      customOrganiserName: this.props.location.state.customOrganiserName,
      eventdate: this.props.location.state.eventdate,
      eventid: this.props.location.state.eventid,
      poster: this.props.location.state.poster,
      theme: this.props.location.state.theme,
      venue: this.props.location.state.venue,
      expectednum: 0,
      enddate: this.props.location.state.enddate,
      time: this.props.location.state.time,
      endtime: this.props.location.state.endtime,
      event_date: this.props.location.state.event_date,
      finish_date: this.props.location.state.finish_date,
      description: 'Coming soon...',
      spinning: 'none',
      updateDisplay: 'block',
      saveBtn: 'save-btn',
      loader: true,
      allowRefund: 0,
      refundPolicyLocked: 0,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const eventid = this.props.location.state.eventid

    const businessname = localStorage.getItem('businessname')
    document.title = businessname + ' - Edit '

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GET-PRIVATE-EVENT-DETAILS&eventid=${eventid}`,
      { withCredentials: true },
    ).then((response) => {
      this.setState({
        loader: false,
        description: response.data.description,
        eventname: response.data.eventName,
        customOrganiserName: response.data.customOrganiserName,
        venue: response.data.eventLocation,
        theme: response.data.theme,
        expectednum: response.data.numOfAttendees,
        eventdate: response.data.eventDate,
        enddate: response.data.endDate,
        time: response.data.startTime,
        endtime: response.data.endTime,
        finish_date: response.data.endDate,
        event_date: response.data.eventDate,
        allowRefund: response.data.refundsAllowed,
        refundPolicyLocked: response.data.refundPolicyLocked,
      })
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
    clearTimeout(this.msgTimer)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  handleEventname = (event) => {
    this.setState({ eventname: event.target.value, errorDisplay: 'none' })
  }

  handleOrganiserName = (event) => {
    this.setState({ customOrganiserName: event.target.value, errorDisplay: 'none' })
  }

  handleVenue = (event) => {
    this.setState({ venue: event.target.value, errorDisplay: 'none' })
  }

  handleTheme = (event) => {
    this.setState({ theme: event.target.value, errorDisplay: 'none' })
  }

  handleExpected = (event) => {
    this.setState({ expectednum: event.target.value, errorDisplay: 'none' })
  }

  handleDate = (event) => {
    this.setState({ event_date: event.target.value, errorDisplay: 'none' })
  }

  handleEnddate = (event) => {
    this.setState({ finish_date: event.target.value, errorDisplay: 'none' })
  }

  handleTime = (event) => {
    this.setState({ time: event.target.value, errorDisplay: 'none' })
  }

  handleEndtime = (event) => {
    this.setState({ endtime: event.target.value, errorDisplay: 'none' })
  }

  handleDescription = (event) => {
    this.setState({ description: event.target.value, errorDisplay: 'none' })
  }

  refundSetting = () => {
    this.setState((prev) => ({ allowRefund: prev.allowRefund == 0 ? 1 : 0 }))
  }

  showMessage = (message, type) => {
    this.setState({
      error: message,
      errorDisplay: 'block',
      successError: type,
    })
    clearTimeout(this.msgTimer)
    this.msgTimer = setTimeout(() => {
      this.setState({ errorDisplay: 'none' })
    }, 5000)
  }

  close = () => {
    this.setState({ errorDisplay: 'none' })
  }

  update = () => {
    const businessid = localStorage.getItem('businessid')
    const eventid = this.props.location.state.eventid
    const {
      eventname,
      customOrganiserName,
      venue,
      theme,
      expectednum,
      time,
      endtime,
      description,
      finish_date,
      event_date,
    } = this.state

    const fail = (message) => this.showMessage(message, 'error-login')

    if (eventname.trim() === '') {
      fail('Please enter event name')
    } else if (venue.trim() === '') {
      fail('Please enter venue')
    } else if (expectednum <= 0) {
      fail('Enter estimated Number of Attendees')
    } else if (event_date === '') {
      fail('Enter the event date')
    } else if (finish_date === '') {
      fail('Enter the event end date')
    } else if (time.trim() === '') {
      fail('Enter event time')
    } else if (endtime.trim() === '') {
      fail('Enter event end time')
    } else if (description.trim() === '') {
      fail('Enter description')
    } else {
      this.setState({
        updateDisplay: 'none',
        spinning: 'block',
        saveBtn: 'btn-disabled',
      })
      const data = new FormData()
      data.append('query', 'ADDEVENT')
      data.append('subquery', 'UPDATEEVENT')
      data.append('eventid', eventid)
      data.append('visa', '1')
      data.append('cash', '0')
      data.append('accountid', businessid)
      data.append('event', eventname)
      data.append('customOrganiserName', customOrganiserName)
      data.append('venue', venue)
      data.append('theme', theme)
      data.append('expected', expectednum)
      data.append('startdate', event_date)
      data.append('enddate', finish_date)
      data.append('starttime', time)
      data.append('endtime', endtime)
      data.append('description', description)
      data.append('refunds_allowed', this.state.allowRefund)

      Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
        withCredentials: true,
      })
        .then((response) => {
          this.setState({
            updateDisplay: 'block',
            spinning: 'none',
            saveBtn: 'save-btn',
          })
          this.showMessage(
            response.data.message,
            response.data.status === 'success' ? 'success-login' : 'error-login',
          )
        })
        .catch((error) => {
          this.setState({
            updateDisplay: 'block',
            spinning: 'none',
            saveBtn: 'save-btn',
          })
          this.showMessage(error.response?.data || error.message, 'error-login')
        })
    }
  }

  render() {
    if (localStorage.getItem('businessname') === null) {
      return <Redirect to="/login" />
    }

    const { collapsed, isMobile } = this.state
    const accounttype = localStorage.getItem('accounttype')
    const busy = this.state.spinning === 'block'
    const locked = this.state.refundPolicyLocked == 1
    const isSuccess = this.state.successError === 'success-login'

    const hasSidebar = accounttype === 'customer' || accounttype === 'business'
    const sidebarOffset =
      !hasSidebar || isMobile ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH

    return (
      <div className="view">
        <style>{styles}</style>

        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}

        {hasSidebar && isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}
        {hasSidebar && isMobile && collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div
          style={{
            marginTop: 48,
            marginLeft: sidebarOffset,
            width: `calc(100% - ${sidebarOffset}px)`,
            padding: '0 16px',
            transition: 'margin-left .25s ease, width .25s ease',
          }}
        >
          <div className="ae">
            <button type="button" className="ae-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              Back
            </button>

            <div className="ae-head">
              <h1 className="ae-title">Edit event</h1>
              <p className="ae-sub">Update your event details and save your changes.</p>
            </div>

            {this.state.loader ? (
              <div className="ae-load">
                <ClipLoader size={28} color={C.ink} />
              </div>
            ) : (
              <>
                {/* 1 - Basics */}
                <div className="ae-card">
                  <div className="ae-card-h">
                    <span className="ae-step">1</span>
                    <h2 className="ae-card-t">Event basics</h2>
                  </div>
                  <div className="ae-grid">
                    <Field label="Event name" required full>
                      <input
                        type="text"
                        placeholder="Event name"
                        value={this.state.eventname}
                        onChange={this.handleEventname}
                        className="ae-input"
                      />
                    </Field>

                    <Field
                      label="Organizer name"
                      hint="If left empty, it defaults to your account name."
                      full
                    >
                      <input
                        type="text"
                        placeholder="If not set, defaults to account name"
                        value={this.state.customOrganiserName}
                        onChange={this.handleOrganiserName}
                        className="ae-input"
                      />
                    </Field>
                  </div>
                </div>

                {/* 2 - Venue */}
                <div className="ae-card">
                  <div className="ae-card-h">
                    <span className="ae-step">2</span>
                    <h2 className="ae-card-t">Venue and audience</h2>
                  </div>
                  <div className="ae-grid">
                    <Field label="Venue" required full>
                      <input
                        type="text"
                        id="location-search-input"
                        placeholder="Enter your address or zip code"
                        value={this.state.venue}
                        onChange={this.handleVenue}
                        className="ae-input"
                      />
                    </Field>

                    <Field label="Theme">
                      <input
                        type="text"
                        placeholder="Theme"
                        value={this.state.theme}
                        onChange={this.handleTheme}
                        className="ae-input"
                      />
                    </Field>

                    <Field label="Estimated number of attendees" required>
                      <input
                        type="text"
                        inputMode="numeric"
                        placeholder="Number expected to attend"
                        value={this.state.expectednum}
                        onChange={this.handleExpected}
                        className="ae-input"
                      />
                    </Field>
                  </div>
                </div>

                {/* 3 - Date and time */}
                <div className="ae-card">
                  <div className="ae-card-h">
                    <span className="ae-step">3</span>
                    <h2 className="ae-card-t">Date and time</h2>
                  </div>
                  <div className="ae-grid">
                    <Field label="Start date" required>
                      <input
                        type="date"
                        value={this.state.event_date}
                        onChange={this.handleDate}
                        className="ae-input"
                      />
                    </Field>

                    <Field label="End date" required>
                      <input
                        type="date"
                        value={this.state.finish_date}
                        min={this.state.event_date || undefined}
                        onChange={this.handleEnddate}
                        className="ae-input"
                      />
                    </Field>

                    <Field label="Start time" required>
                      <input
                        type="time"
                        value={this.state.time}
                        onChange={this.handleTime}
                        className="ae-input"
                      />
                    </Field>

                    <Field label="End time" required>
                      <input
                        type="time"
                        value={this.state.endtime}
                        onChange={this.handleEndtime}
                        className="ae-input"
                      />
                    </Field>
                  </div>
                </div>

                {/* 4 - Description */}
                <div className="ae-card">
                  <div className="ae-card-h">
                    <span className="ae-step">4</span>
                    <h2 className="ae-card-t">Description</h2>
                  </div>
                  <Field label="Tell people what to expect" required>
                    <textarea
                      placeholder="Description"
                      value={this.state.description}
                      onChange={this.handleDescription}
                      className="ae-input"
                      rows={5}
                    />
                  </Field>
                </div>

                {/* 5 - Refunds */}
                <div className="ae-card">
                  <div className="ae-card-h">
                    <span className="ae-step">5</span>
                    <h2 className="ae-card-t">Refunds</h2>
                  </div>
                  <label className={`ae-check ${locked ? 'is-locked' : ''}`} htmlFor="allow_refund">
                    <input
                      type="checkbox"
                      id="allow_refund"
                      checked={this.state.allowRefund == 1}
                      disabled={locked}
                      onChange={this.refundSetting}
                    />
                    Allow refunds
                  </label>
                  <div className={`ae-note ${locked ? 'is-warn' : ''}`}>
                    {locked ? (
                      <IoAlertCircleOutline size={20} />
                    ) : (
                      <IoInformationCircleOutline size={20} />
                    )}
                    <div>
                      {locked ? (
                        <>
                          <b>Refund settings are now locked</b>
                          Ticket sales have begun, and this setting can no longer be changed. Buyers
                          will follow the refund policy that was in place before the first ticket
                          sale. If no policy was set, this event is treated as non-refundable by
                          default.
                        </>
                      ) : (
                        <>
                          <b>Refunds are processed through Karamale</b>
                          This setting determines whether buyers can request refunds. Once ticket
                          sales begin, it becomes final and cannot be changed.
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {this.state.errorDisplay === 'block' && this.state.error ? (
                  <div
                    className={`ae-msg ${isSuccess ? 'is-ok' : 'is-err'}`}
                    role={isSuccess ? 'status' : 'alert'}
                    onClick={() => this.close()}
                  >
                    {isSuccess ? (
                      <IoCheckmarkCircleOutline size={20} />
                    ) : (
                      <IoAlertCircleOutline size={20} />
                    )}
                    <span>{String(this.state.error)}</span>
                  </div>
                ) : null}

                <div className="ae-actions">
                  <button
                    type="button"
                    className="ae-btn"
                    onClick={() => this.update()}
                    disabled={busy}
                  >
                    {busy ? (
                      <ClipLoader color={'#ffffff'} loading={true} size={20} />
                    ) : (
                      'Save changes'
                    )}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Updateeventdetails
